import {
	ProductVM,
	ScreenType,
	TrackingEventStatus,
	TrackingEventType
} from '../../../common/view-model';
import './ProductInformationComponent.scss';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { productInformationState } from './model';
import { HowGoodScore } from '../howGoodScore/HowGoodScoreComponent';
import { v4 as uuidv4 } from 'uuid';
import { handleTracking } from '../../../helpers/handelTracking';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/AppReducer';
import { Product, UserType } from '../../../common/model';
import { Link, useNavigate } from 'react-router';
import { BoothNumberComponent } from '../../UI/BoothNumberComponent/BoothNumberComponent';
import { ExpoLabelComponent } from '../../UI/ExpoLabelComponent/ExpoLabelComponent';
import { AppActions } from '../../../redux/AppActions';
import MarketReadyOverlay from '../marketReadyOverlay/MarketReadyOverlay';
import { ExpoEastOverlay } from '../../ExpoEastOverlay/ExpoEastOverlay';
import { findUserAccessType } from '../../../helpers/findUserAccessType';
import { isCurrentUserAnonymous } from '../../../helpers/authenticationHelper';
import { publicProductDetailsActions } from '../../../common/constants';
import { ProductBadgesComponent } from '../badges/ProductBadgesComponent';
import { useAppDispatch } from '../../../redux/store';
import { salesInformationState } from '../accordion/salesInformation/model';
import { DistributionComponent } from '../accordion/distribution/DistributionComponent';
import SpinsMetricsComponent from '../accordion/spinMetrics/SpinsMetricsComponent';
import { DescriptionComponent } from '../accordion/description/DescriptionComponent';
import { SubstainabiltyComponent } from '../accordion/substainability/SubstainabiltyComponent';
import { validateAllMetricsUnavailable } from '../../../helpers/validateAllMetricsUnavailable';
import { ReviewsAndRatingsSubDetail } from '../ReviewsAndRatings/ReviewsAndRatingsSubDetail';
import { validateAllImagesHaveError } from '../../../helpers/validateAllImagesHaveError';
import { ingredientListMapper } from '../../../helpers/ingredientListMapper';
import { ProductCertificationsComponent } from '../certifications/ProductCertificationsComponent';
import { SwapCardProfileLink } from '../../SwapCardProfileLink/SwapCardProfileLink';

// import { description_list } from '../../NewProfile/SocialMediaKit/model';

interface IProductInformationComponentProps {
	product: ProductVM | undefined;
	registerUserClickEvent: (event: string) => void;
	reviewCount?: number;
	averageRating?: number;
}
export const ProductInformationComponent: FC<IProductInformationComponentProps> = ({
	product,
	registerUserClickEvent,
	reviewCount,
	averageRating
}) => {
	const handleShow = (score: any) => {
		if (isCurrentUserAnonymous()) {
			// registerUserClickEvent(publicProductDetailsActions.CLICK_HG_SCORE);
		}
		handleTracking({
			transactionId: uuidv4(),
			status: TrackingEventStatus.SUCCESS,
			type: TrackingEventType.HOW_GOOD,
			timeStamp: new Date().toDateString(),
			entityId: product?.id!,
			eventPayload: {
				id: product?.id!,
				name: product?.name!,
				type: product?.taxonomy[0] ? product?.taxonomy[0].name! : '',
				url: window.location.href,
				tags: [],
				metadata: {
					user_email: userState?.business_email,
					user_firstName: userState?.first_name,
					user_lastName: userState?.last_name,
					user_type: userState?.user_type,
					environment: import.meta.env.VITE_ENV_NAME
				}
			}
		});
		dispatch(
			AppActions.setModalContent({
				content: (
					<HowGoodScore
						score={score}
						product={product}
						initialOpen={true}
						registerUserClickEvent={registerUserClickEvent}
					/>
				),
				showCloseIcon: true,
				canScroll: true,
				closeOnDocumentClick: true
			})
		);
	};
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [state, setState] = useState({ ...productInformationState, product });
	const mapper = (product?: Product): ProductVM | undefined => {
		if (product) {
			return {
				...product,
				filtered: false,
				hasNavigate: true,
				allImagesHaveError: validateAllImagesHaveError(product.images as any[]),
				ingredientsList: ingredientListMapper(product.ingredientsList)
			};
		}
	};
	const [currentProduct, setCurrentProduct] = useState<ProductVM | undefined>(mapper(product));
	const [salesInformation] = useState({ ...salesInformationState });
	const userState = useSelector((state: RootState) => state.appState.userState?.user);
	const deviceScreen = useSelector((state: RootState) => state.appState.deviceScreen);
	const currentEvent = useSelector(
		(state: RootState) => state.appState.storeState?.getCurrentEvent
	);

	const allMetricsUnavailable = validateAllMetricsUnavailable(product);

	const tabs = [
		{
			key: 'description',
			label: 'Description',
			component: <DescriptionComponent product={product} />
		},
		{
			key: 'spins',
			label: 'SPINS Metrics',
			component: (
				<SpinsMetricsComponent product={product} allMetricsUnavailable={allMetricsUnavailable} />
			)
		},
		{
			key: 'distribution',
			label: 'Distribution',
			component: <DistributionComponent product={product} />
		},
		{
			key: 'substainability',
			label: 'Sustainability',
			component: <SubstainabiltyComponent product={product} handleShow={handleShow} />
		}
	];

	const [activeTab, setActiveTab] = useState('description');

	const handleGoToBrand = () => {
		if (isCurrentUserAnonymous()) {
			registerUserClickEvent(publicProductDetailsActions.CLICK_CONTACT_BRAND);
		}
		handleTracking({
			transactionId: uuidv4(),
			status: TrackingEventStatus.SUCCESS,
			type: TrackingEventType.CONTACT_BRAND,
			timeStamp: new Date().toISOString(),
			entityId: state.product?.id!,
			eventPayload: {
				id: state.product?.id!,
				name: state.product?.name!,
				type: state.product?.taxonomy[0].name!,
				url: window.location.href,
				tags: [],
				metadata: {
					product_brand_name: state.product?.brand.name,
					user_type: userState?.user_type,
					enviroment: import.meta.env.VITE_ENV_NAME
				}
			}
		});
		handleFocusContactInfo();
	};
	const handleRequestSample = () => {
		if (isCurrentUserAnonymous()) {
			registerUserClickEvent(publicProductDetailsActions.CLICK_REQUEST_SAMPLE);
		}
		handleTracking({
			transactionId: uuidv4(),
			status: TrackingEventStatus.SUCCESS,
			type: TrackingEventType.REQUEST_SAMPLE,
			timeStamp: new Date().toISOString(),
			entityId: state.product?.id!,
			eventPayload: {
				id: state.product?.id!,
				name: state.product?.name!,
				type: state.product?.taxonomy[0].name!,
				url: window.location.href,
				tags: [],
				metadata: {
					product_brand_name: state.product?.brand.name,
					user_type: userState?.user_type,
					enviroment: import.meta.env.VITE_ENV_NAME
				}
			}
		});
		handleFocusAboutBrand();
	};

	const handleFocusContactInfo = () => {
		const el = document.getElementById('contact-info');
		if (el) {
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	const handleFocusAboutBrand = () => {
		const elements = document.querySelectorAll('[data-custom-attribute="about-brand"]');
		const element = Array.from(elements).find(
			element =>
				element instanceof HTMLElement && window.getComputedStyle(element).display !== 'none'
		);
		element?.scrollIntoView({ behavior: 'smooth' });
		dispatch(AppActions.setContactAccordionOpen(true));
	};
	const handleNavigateToBrand = (event: any) => {
		event.preventDefault();
		if (isCurrentUserAnonymous()) {
			registerUserClickEvent(publicProductDetailsActions.CLICK_GO_TO_BRAND_PAGE);
		}
		navigate(`/brand/${product?.brand.id}`);
	};

	const openExpoPopUpCallback = useCallback(() => {
		dispatch(
			AppActions.setModalContent({
				content: <ExpoEastOverlay />,
				showCloseIcon: false,
				canScroll: true,
				closeOnDocumentClick: true
			})
		);

		handleTracking({
			transactionId: uuidv4(),
			status: TrackingEventStatus.SUCCESS,
			type: TrackingEventType.CLICK_ON_SEE_US_EXPO_BUTTON,
			timeStamp: new Date().toISOString(),
			entityId: product?.id!,
			eventPayload: {
				id: product?.id!,
				name: product?.name!,
				type: product?.taxonomy[0].name!,
				url: window.location.href,
				tags: [],
				metadata: {
					user_id: userState?.id,
					user_type: userState?.user_type,
					environment: import.meta.env.VITE_ENV_NAME,
					event_id: currentEvent?.id,
					event_name: currentEvent?.name
				}
			}
		});
	}, [dispatch]);

	useEffect(() => {
		setState({ ...productInformationState, product });
	}, [product]);

	useEffect(() => {
		setCurrentProduct(mapper(product));
	}, [product]);

	const handleClickMarketReady = useCallback(() => {
		dispatch(
			AppActions.setModalContent({
				content: <MarketReadyOverlay />,
				showCloseIcon: false,
				canScroll: true,
				closeOnDocumentClick: true
			})
		);
		handleTracking({
			transactionId: uuidv4(),
			status: TrackingEventStatus.SUCCESS,
			type: TrackingEventType.MARKET_READY,
			timeStamp: new Date().toISOString(),
			entityId: state.product?.id!,
			eventPayload: {
				id: state.product?.id!,
				name: state.product?.name!,
				type: state.product?.taxonomy[0].name!,
				url: window.location.href,
				tags: [],
				metadata: {
					product_brand_name: state.product?.brand.name,
					user_type: userState?.user_type,
					enviroment: import.meta.env.VITE_ENV_NAME
				}
			}
		});
	}, [dispatch, state.product, userState?.user_type]);
	const reviewsCount = reviewCount ?? 0;
	const swapcardProfileLinkFlag = import.meta.env.VITE_SHOW_SWAPCARD_PROFILE_LINK;

	const nameRef = useRef<HTMLDivElement | null>(null);
	const [isTruncated, setIsTruncated] = useState(false);
	const [showOverlay, setShowOverlay] = useState(false);

	useEffect(() => {
		const el = nameRef.current;
		if (!el) return;

		// Check if text is actually truncated
		const isOverflowing = el.scrollHeight > el.clientHeight;
		setIsTruncated(isOverflowing);
	}, [name]);

	// const handleClick = () => {
	// 	if (isTruncated) {
	// 		setShowOverlay(true);
	// 	}
	// };

	return (
		<div data-testid='product-information' className='product-information'>
			<div className='overview'>
				<div className='details'>
					{state.product?.howGoodScore?.show_howgood_score &&
						product?.howGoodScore?.source_retail_raiting &&
						state.product?.brand.boothNumber &&
						currentEvent &&
						currentEvent != null && (
							<div
								className={`label-container ${
									deviceScreen === ScreenType.MOBILE ? 'mobile-wrapper' : ''
								}`}
							>
								<div className='top-attributes'>
									<div className='product-howgood-market'>
										{state.product?.howGoodScore?.show_howgood_score &&
											product?.howGoodScore?.source_retail_raiting && (
												<HowGoodScore
													score={state.product?.howGoodScore?.score}
													product={product}
													range={product?.howGoodScore?.source_retail_raiting}
													categoryAverage={product?.howGoodScore?.category_average}
													registerUserClickEvent={registerUserClickEvent}
													handleShow={handleShow}
												/>
											)}
									</div>
									{state.product?.brand.boothNumber && currentEvent && currentEvent != null && (
										<div className='ExpoBooth'>
											<div className='ExpoLabel'>
												<ExpoLabelComponent
													text={`${currentEvent?.label || currentEvent.name}`}
													labelStyle={`large ${currentEvent?.name
														.replace(/\s+/g, '')
														.toLocaleLowerCase()
														.trim()}`}
													icon=''
													showAnimation={true}
													onClick={openExpoPopUpCallback}
												/>
											</div>
											<div className='BoothNumber'>
												<BoothNumberComponent
													text={`Booth #${state.product?.brand.boothNumber}${
														state.product?.brand.hall_name
															? ` ${state.product.brand.hall_name}`
															: ''
													}`}
													boothStyle='primary'
													icon='ri-store-3-line'
												/>
											</div>
										</div>
									)}
								</div>
							</div>
						)}
					<div className='brandname-productname'>
						<div className='brand'>
							<Link
								to={`/brand/${product?.brand.id}`}
								className='product-brand'
								onClick={(event: any) => handleNavigateToBrand(event)}
							>
								{state.product?.brand?.name}
							</Link>
							{swapcardProfileLinkFlag === 'true' &&
								state.product?.brand?.slug &&
								state.product?.brand?.exhibitor_id && (
									<div className='swapcard-profile-link-product'>
										{' '}
										<SwapCardProfileLink
											text='See us in the show app!'
											style='product'
											exhibitor_id={state.product?.brand?.exhibitor_id}
										/>
									</div>
								)}
						</div>
						<div>
							{showOverlay && <div className='overlay-content'>{state.product?.name}</div>}
							<div
								ref={nameRef}
								className={`product-name ${isTruncated ? 'clickable' : ''}`}
								onClick={() => isTruncated && setShowOverlay(true)}
								onMouseLeave={() => isTruncated && setShowOverlay(false)}
							>
								{state.product?.name}
							</div>
						</div>
					</div>
					{reviewsCount > 0 && (
						<ReviewsAndRatingsSubDetail ratings={averageRating} count={reviewCount} />
					)}
					<div className='product-sub-detail'>
						<span className='product-sub-detail-title'>
							{product?.manufacturerSuggestedRetailPrice && (
								<span className='details'>
									{' '}
									{product?.manufacturerSuggestedRetailPrice}{' '}
									{salesInformation.manufacturerSuggestedRetailPriceText}
									{(state?.product?.netContent || state?.product?.launchYear) && (
										<span className='dot'>{'.'}</span>
									)}
								</span>
							)}

							{state?.product?.netContent && (
								<span className='details'>
									{state?.product?.netContent}
									{state?.product?.launchYear && <span className='dot'>{'.'}</span>}
								</span>
							)}

							{state?.product?.launchYear && (
								<span className='details'>
									{'Released '}
									{state.product.launchYear}
								</span>
							)}
						</span>
					</div>

					<ProductBadgesComponent
						marketReady={state.product?.marketReady || false}
						nextyBadge={state.product?.isNextyFinalist || false}
						handleClickMarketReady={handleClickMarketReady}
					/>
					<div className='links'>
						<div
							data-testid='go-to-brand-button'
							className='contact-button'
							onClick={handleGoToBrand}
						>
							Contact {state.product?.brand?.name}
						</div>
						{findUserAccessType(userState?.user_type) !== UserType.Brand && (
							<div className='learn-more-about-section' onClick={handleRequestSample}>
								<div data-testid='request-sample-button' className='learn-more-about'>
									Learn More About {state.product?.brand?.name}
								</div>
								<i className='ri-arrow-right-s-line'></i>
							</div>
						)}
					</div>
					{deviceScreen === ScreenType.MOBILE &&
						currentProduct?.certifications &&
						currentProduct.certifications.length > 0 && (
							<div>
								<ProductCertificationsComponent
									product={currentProduct}
									deviceScreen={deviceScreen}
									registerUserClickEvent={registerUserClickEvent}
								/>
							</div>
						)}
					{deviceScreen !== ScreenType.TABLET && deviceScreen !== ScreenType.SMALL_DESKTOP && (
						<div className='tabs-wrapper'>
							{/* TAB HEADERS */}
							<div className='tabs-header'>
								{tabs.map(tab =>
									(tab.label === 'Sustainability' && state.product?.howGoodScore?.score === null) ||
									(tab.label === 'SPINS Metrics' &&
										state.product?.spinsMetrics?.dollars === null) ? null : (
										<div key={tab.key} className='tab-item'>
											<button
												className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
												onClick={() => setActiveTab(tab.key)}
											>
												{tab.label === 'SPINS Metrics' ? (
													<>
														SPINS<sup>TM</sup> Metrics
													</>
												) : (
													tab.label
												)}
											</button>

											{/* Small underline under active tab */}
											{activeTab === tab.key && <div className='active-underline'></div>}
										</div>
									)
								)}
							</div>

							{/* Big grey underline */}
							<div className='big-underline'></div>

							{/* CONTENT COMPONENT */}
							<div className='tab-content'>{tabs.find(t => t.key === activeTab)?.component}</div>
						</div>
					)}
					{(deviceScreen === ScreenType.TABLET || deviceScreen === ScreenType.SMALL_DESKTOP) &&
						currentProduct?.certifications &&
						currentProduct.certifications.length > 0 && (
							<div>
								<ProductCertificationsComponent
									product={currentProduct}
									deviceScreen={deviceScreen}
									registerUserClickEvent={registerUserClickEvent}
								/>
							</div>
						)}
				</div>
			</div>
		</div>
	);
};
